import * as React from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import EditPolizaRenewal from "./EditPolizaRenewal";
import "./polizaRenewal.scss";

var EditPolizaRenewalContainer = function EditPolizaRenewalContainer(props) {
  var queryClient = new QueryClient();
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(EditPolizaRenewal, props));
};

export default EditPolizaRenewalContainer;